import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { AgenteFinanceiroResolver } from 'src/app/shared/resolvers/agente-financeiro.resolver';

import { CanDeactivateGuardService } from '../../core/can-deactivate-guard.service';
import { EmpresasBloqueadasPesquisaComponent } from './empresas-bloqueadas-pesquisa.component';
import { EscolhaModalidadeGuard } from 'src/app/interceptors/escolha-modalidade.guard';
import { EnvioConsultaProtocoloEmpresaComponent } from './envio-consulta-protocolo-empresa/envio-consulta-protocolo-empresa.component';
import { EmpresasBloqueadasLoteComponent } from './empresas-bloqueadas-lote.component';
import { EmpresasBloqueadasIndividualComponent } from './empresas-bloqueadas-individual.component';


const routes: Routes = [
  {
    path: 'empresas-bloqueadas',
    component: EmpresasBloqueadasPesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
    	agentes: AgenteFinanceiroResolver,
    },
    data: { refreshAgentes: true }
    // data: { canReuse: false } // inviabilizado pelas melhorias da SOL00129375
  },
  {
    path: 'empresas-bloqueadas/cadastro/lote',
    component: EmpresasBloqueadasLoteComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false }
  },
  {
    path: 'empresas-bloqueadas/cadastro/individual',
    component: EmpresasBloqueadasIndividualComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false }
  },
  {
    path: 'empresas-bloqueadas/envio-consulta',
    component: EnvioConsultaProtocoloEmpresaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
    	agentes: AgenteFinanceiroResolver,
    },
    data: { refreshAgentes: true }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmpresasBloqueadasRoutingModule { }
